import React from 'react';

export const UsageReportingHelp: React.FC = () => (
  <div>
    <h4>Usage Reporting</h4>
    <p>View your account&apos;s trip monitoring and API usage metrics.</p>
    <p>
      Use the timeframe filter to adjust the date range and data granularity
      (Daily, Weekly, or Monthly).
    </p>
    <p>
      Switch between the <strong>Trips Monitored</strong> and{' '}
      <strong>Trip Status API</strong> tabs to view different usage metrics.
    </p>
    <p>Click EXPORT on any data table to download the data as a CSV file.</p>
  </div>
);
